// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type CheckCircle20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckCircle20: FC<CheckCircle20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="m13.409 8.305-4.339 4.32-2.479-2.46.93-.93 1.55 1.53 3.408-3.39.93.93Z" />
            <path
                d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default CheckCircle20;
